export default __webpack_public_path__ + "static/media/_default_nft.ce305e70.svg";